(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

class MsSiteHeader {
constructor(header) {
this.header = header;
this.toggle = this.header.querySelector('[data-ms-menu-toggle]');
this.mobileMenu = this.header.querySelector('[data-ms-mobile-menu]');
this.weglotTarget = this.header.querySelector('[data-ms-weglot-target]');
this.weglotDesktop = this.header.querySelector('[data-ms-weglot-desktop]');
this.weglotMobile = this.header.querySelector('[data-ms-weglot-mobile]');
this.mobileSubmenuToggle = this.header.querySelector('[data-ms-mobile-submenu-toggle]');
this.mobileSubmenu = this.header.querySelector('[data-ms-mobile-submenu]');
this.onToggleClick = this.onToggleClick.bind(this);
this.onMobileSubmenuToggle = this.onMobileSubmenuToggle.bind(this);
this.onMobileMenuClick = this.onMobileMenuClick.bind(this);
this.onKeydown = this.onKeydown.bind(this);
this.onResize = this.onResize.bind(this);
}

connectedCallback() {
if (this.toggle && this.mobileMenu) {
this.toggle.addEventListener('click', this.onToggleClick);
this.mobileMenu.addEventListener('click', this.onMobileMenuClick);
document.addEventListener('keydown', this.onKeydown);
window.addEventListener('resize', this.onResize);
}
if (this.mobileSubmenuToggle && this.mobileSubmenu) {
this.mobileSubmenuToggle.addEventListener('click', this.onMobileSubmenuToggle);
}
this.syncWeglotSlot();
}

disconnectedCallback() {
if (this.toggle) this.toggle.removeEventListener('click', this.onToggleClick);
if (this.mobileMenu) this.mobileMenu.removeEventListener('click', this.onMobileMenuClick);
if (this.mobileSubmenuToggle) this.mobileSubmenuToggle.removeEventListener('click', this.onMobileSubmenuToggle);
document.removeEventListener('keydown', this.onKeydown);
window.removeEventListener('resize', this.onResize);
}

onToggleClick() {
this.isOpen ? this.close() : this.open();
}

onMobileSubmenuToggle() {
if (!this.mobileSubmenuToggle || !this.mobileSubmenu) return;
const isExpanded = this.mobileSubmenuToggle.getAttribute('aria-expanded') === 'true';
this.mobileSubmenuToggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
this.mobileSubmenu.hidden = isExpanded;
}

onMobileMenuClick(event) {
const link = event.target.closest('a');
if (link && this.isOpen) this.close();
}

onKeydown(event) {
if (event.key === 'Escape' && this.isOpen) this.close();
}

onResize() {
if (window.matchMedia('(min-width: 990px)').matches && this.isOpen) this.close();
this.syncWeglotSlot();
}

syncWeglotSlot() {
if (!this.weglotTarget || !this.weglotDesktop || !this.weglotMobile) return;
const shouldUseMobileSlot = window.matchMedia('(max-width: 989px)').matches && this.isOpen;
const targetSlot = shouldUseMobileSlot ? this.weglotMobile : this.weglotDesktop;
if (this.weglotTarget.parentElement !== targetSlot) targetSlot.appendChild(this.weglotTarget);
}

open() {
this.isOpen = true;
this.header.classList.add('is-open');
this.mobileMenu.hidden = false;
requestAnimationFrame(() => this.mobileMenu.classList.add('is-visible'));
this.toggle.setAttribute('aria-expanded', 'true');
this.toggle.setAttribute('aria-label', 'Close navigation');
document.body.classList.add('ms-menu-open');
this.syncWeglotSlot();
}

close() {
this.isOpen = false;
this.header.classList.remove('is-open');
this.mobileMenu.classList.remove('is-visible');
this.toggle.setAttribute('aria-expanded', 'false');
this.toggle.setAttribute('aria-label', 'Open navigation');
if (this.mobileSubmenuToggle && this.mobileSubmenu) {
this.mobileSubmenuToggle.setAttribute('aria-expanded', 'false');
this.mobileSubmenu.hidden = true;
}
document.body.classList.remove('ms-menu-open');
this.syncWeglotSlot();
window.setTimeout(() => {
if (!this.isOpen) this.mobileMenu.hidden = true;
	}, 320);
}
}

document.querySelectorAll('[data-ms-site-header]').forEach((header) => {
if (header.msSiteHeader) return;
header.msSiteHeader = new MsSiteHeader(header);
header.msSiteHeader.connectedCallback();
});



class StickyHeader extends HTMLElement {



constructor() {



super();



}







connectedCallback() {



this.header = document.querySelector('.section-header');



this.headerIsAlwaysSticky =



this.getAttribute('data-sticky-type') === 'always' ||



this.getAttribute('data-sticky-type') === 'reduce-logo-size';



this.headerBounds = {};







this.setHeaderHeight();







window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));







if (this.headerIsAlwaysSticky) {



this.header.classList.add('shopify-section-header-sticky');



}







this.currentScrollTop = 0;



this.preventReveal = false;



this.predictiveSearch = this.querySelector('predictive-search');







this.onScrollHandler = this.onScroll.bind(this);



this.hideHeaderOnScrollUp = () => (this.preventReveal = true);







this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);



window.addEventListener('scroll', this.onScrollHandler, false);







this.createObserver();



}







setHeaderHeight() {



document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);



}







disconnectedCallback() {



this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);



window.removeEventListener('scroll', this.onScrollHandler);



}







createObserver() {



let observer = new IntersectionObserver((entries, observer) => {



this.headerBounds = entries[0].intersectionRect;



observer.disconnect();



});







observer.observe(this.header);



}







onScroll() {



const scrollTop = window.pageYOffset || document.documentElement.scrollTop;







if (this.predictiveSearch && this.predictiveSearch.isOpen) return;







if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {



this.header.classList.add('scrolled-past-header');



if (this.preventHide) return;



requestAnimationFrame(this.hide.bind(this));



} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {



this.header.classList.add('scrolled-past-header');



if (!this.preventReveal) {



requestAnimationFrame(this.reveal.bind(this));



} else {



window.clearTimeout(this.isScrolling);







this.isScrolling = setTimeout(() => {



this.preventReveal = false;



}, 66);







requestAnimationFrame(this.hide.bind(this));



}



} else if (scrollTop <= this.headerBounds.top) {



this.header.classList.remove('scrolled-past-header');



requestAnimationFrame(this.reset.bind(this));



}







this.currentScrollTop = scrollTop;



}







hide() {



if (this.headerIsAlwaysSticky) return;



this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');



this.closeMenuDisclosure();



this.closeSearchModal();



}







reveal() {



if (this.headerIsAlwaysSticky) return;



this.header.classList.add('shopify-section-header-sticky', 'animate');



this.header.classList.remove('shopify-section-header-hidden');



}







reset() {



if (this.headerIsAlwaysSticky) return;



this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');



}







closeMenuDisclosure() {



this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');



this.disclosures.forEach((disclosure) => disclosure.close());



}







closeSearchModal() {



this.searchModal = this.searchModal || this.header.querySelector('details-modal');



this.searchModal.close(false);



}



}







customElements.define('sticky-header', StickyHeader);




  } catch(e) { console.error(e); }
})();
})();
